import shortcodeData from "emojibase-data/en/shortcodes/iamcal.json";

export type StandardEmoji = { name: string; unicode: string };

const COMMON_NAMES = [
  "thumbsup",
  "heart",
  "joy",
  "smile",
  "sob",
  "eyes",
  "fire",
  "tada",
  "white_check_mark",
  "pray",
  "thinking_face",
  "wave",
  "rocket",
  "100",
  "sparkles",
  "raised_hands",
  "clap",
  "laughing",
  "slightly_smiling_face",
  "heart_eyes",
] as const;

const byName = new Map<string, StandardEmoji>();

function unicodeFromHexcode(hexcode: string) {
  return hexcode
    .split("-")
    .map((point) => String.fromCodePoint(Number.parseInt(point, 16)))
    .join("");
}

for (const [hexcode, rawNames] of Object.entries(shortcodeData as Record<string, string | string[]>)) {
  const unicode = unicodeFromHexcode(hexcode);
  for (const rawName of Array.isArray(rawNames) ? rawNames : [rawNames]) {
    const name = rawName.toLowerCase();
    if (!byName.has(name)) byName.set(name, { name, unicode });
  }
}

export function standardEmojiByName(name: string) {
  return byName.get(name.toLowerCase()) ?? null;
}

export function standardEmojiMatches(query: string, limit = 120) {
  const normalized = query.trim().toLowerCase();
  const matches: StandardEmoji[] = [];
  const seen = new Set<string>();
  const add = (item: StandardEmoji | undefined) => {
    if (!item || seen.has(item.name) || (normalized && !item.name.includes(normalized))) return;
    seen.add(item.name);
    matches.push(item);
  };
  for (const name of COMMON_NAMES) add(byName.get(name));
  if (matches.length < limit) {
    for (const item of byName.values()) {
      add(item);
      if (matches.length >= limit) break;
    }
  }
  return matches;
}

export function commonStandardEmoji() {
  return COMMON_NAMES.flatMap((name) => {
    const item = byName.get(name);
    return item ? [item] : [];
  });
}
